;(() => {
  function getOffsetTop(element) {
    if (!element) {
      return 0
    }

    return getOffsetTop(element.offsetParent) + element.offsetTop
  }

  function scrollTo(hash) {
    const target = document.querySelector(hash)

    if (!target) {
      return
    }

    const tab = target.closest(".tabs__item")

    if (tab) {
      window.showTab(tab.id)
    }

    const header = document.getElementById("header")
    const headerOffset = header ? header.offsetHeight : 0
    const elementPosition = getOffsetTop(target)
    const elementStyle = target.currentStyle || window.getComputedStyle(target)
    const offsetPosition =
      elementPosition - headerOffset - parseInt(elementStyle.marginTop)

    window.skipYouLeadUntilId = target.id

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  function initScrollToHash() {
    if (window.location.hash) {
      scrollTo(window.location.hash)
    }

    document.querySelectorAll('a[href^="#"]').forEach((trigger) => {
      trigger.onclick = function (e) {
        const href = this.getAttribute("href")
        if (!href || href === "#") return
        e.preventDefault()
        scrollTo(href)
      }
    })
  }

  window.addEventListener("load", () => {
    window.lastScrollTop = 0
    initScrollToHash()
  })
})()
